import React from 'react';
import { Permission } from '../../../types/permissions';
import { groupPermissionsBySections } from '../../../utils/permissionSections';
import PermissionItem from './PermissionItem';

interface PermissionsGridProps {
  permissions: Permission[];
  selectedIds: number[];
  disabled: boolean;
  onPermissionToggle: (permissionId: number, checked: boolean) => void;
}

const PermissionsGrid: React.FC<PermissionsGridProps> = ({
  permissions,
  selectedIds,
  disabled,
  onPermissionToggle
}) => {
  // Agrupar permisos por secciones
  const permissionSections = groupPermissionsBySections(permissions);

  return (
    <div className="p-4 rounded-lg">
      <div className="space-y-6">
        {permissionSections.map(section => (
          <div key={section.id} className="bg-white border border-gray-200 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-custom-blue-2 mb-4 pb-2">
              {section.name}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
              {section.permissions.map(permission => (
                <PermissionItem
                  key={permission.id}
                  permission={permission}
                  isSelected={selectedIds.includes(permission.id)}
                  disabled={disabled}
                  onToggle={onPermissionToggle}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PermissionsGrid;
